/**
 * Fix UTF-8 mojibake when text was decoded as Latin-1 instead of UTF-8.
 * Works in both Node (Buffer) and browser (TextDecoder).
 */
function decodeLatin1AsUtf8(text: string): string {
  if (typeof globalThis.Buffer !== "undefined") {
    return Buffer.from(text, "latin1").toString("utf8")
  }
  const bytes = new Uint8Array(text.length)
  for (let i = 0; i < text.length; i++) {
    bytes[i] = text.charCodeAt(i) & 0xff
  }
  return new TextDecoder("utf-8").decode(bytes)
}

export function normalizeTextEncoding(text: string): string {
  if (typeof text !== "string" || !text) return text
  if (!/Ã|Ä|Â|Å/.test(text)) return text
  try {
    return decodeLatin1AsUtf8(text)
  } catch {
    return text
  }
}

